import React from 'react';

const pct = (v) => (v == null ? '—' : `${(Number(v) * 100).toFixed(1)}%`);
const lvl = (v) => {
  if (v == null) return '—';
  const n = Number(v);
  // Currency (and other sub-10 level) series need decimals — AUD/USD at 0.65
  // was rendering as "1" under whole-number formatting.
  if (Math.abs(n) < 10) return n.toFixed(4);
  return n.toLocaleString('en-AU', { maximumFractionDigits: 0 });
};

const asAtDisplay = (iso) => {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime())
    ? null
    : d.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
};

// Asset Class Returns table (page 10): latest index level + 1M/3M/6M/1Y.
export default function IpReturnsTable({ data }) {
  if (!data || !Array.isArray(data.rows) || data.rows.length === 0) {
    return <div className="chart-placeholder">No data available</div>;
  }
  const asAt = asAtDisplay(data.as_at);
  const cell = (v) => <td className={`ip-ret-val ${v == null ? '' : v >= 0 ? 'pos' : 'neg'}`}>{pct(v)}</td>;
  return (
    <table className="ip-ret-table">
      <thead>
        <tr>
          <th className="ip-ret-name">{asAt ? `As at ${asAt}` : ''}</th>
          <th>Latest Value</th>
          <th>Monthly</th>
          <th>Quarterly</th>
          <th>Half Year</th>
          <th>Yearly</th>
        </tr>
      </thead>
      <tbody>
        {data.rows.map((r, i) => (
          <tr key={i}>
            <td className="ip-ret-name">{r.label}</td>
            <td className="ip-ret-lvl">{lvl(r.latest)}</td>
            {cell(r.m)}
            {cell(r.q)}
            {cell(r.h)}
            {cell(r.y)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
